// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CanvasPage.css - PhD Canvas Page Styling */

.canvas-page {
  min-height: 100vh;
  background: var(--bg-gradient);
  color: var(--text-primary);
  padding: 2rem;
}

.canvas-page.print-view {
  background: white;
  color: black;
  padding: 1rem;
}

/* Header Section */
.canvas-header {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2rem;
  background: var(--bg-primary);
  padding: 1.5rem;
  border-radius: 16px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-lg);
}

.canvas-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.print-view .canvas-header {
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-button:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.print-view .back-button {
  display: none;
}

.canvas-title-section {
  display: flex;
  flex-direction: column;
}

.canvas-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  margin-bottom: 0.25rem;
  color: var(--text-primary);
}

.canvas-title-icon {
  color: var(--feature-icon-color);
}

.canvas-subtitle {
  margin: 0;
  color: var(--text-secondary);
  font-size: 1rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.canvas-powered-by {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--text-tertiary);
  font-size: 12px;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.canvas-powered-by:hover {
  opacity: 0.8;
}

.canvas-powered-by-logo {
  height: 1em;
  width: auto;
  vertical-align: middle;
}

.print-view .header-actions {
  display: none;
}

/* Icon-only buttons in canvas header */
.canvas-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.12s ease, box-shadow 0.18s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.canvas-icon-btn svg {
  width: 18px;
  height: 18px;
}

.canvas-icon-btn:hover:not(:disabled) {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.canvas-icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Clear-canvas variant — destructive */
.clear-canvas-btn {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.35);
}

.clear-canvas-btn:hover:not(:disabled) {
  background: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
  box-shadow: 0 4px 12px -2px rgba(239, 68, 68, 0.45);
}

[data-theme="dark"] .clear-canvas-btn {
  color: #f87171;
  border-color: rgba(248, 113, 113, 0.4);
}

[data-theme="dark"] .clear-canvas-btn:hover:not(:disabled) {
  background: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.action-button:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.action-icon.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Stats Section */
.canvas-stats {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  justify-content: center;
}

.stat-item {
  text-align: center;
  background: var(--bg-primary);
  padding: 1.5rem;
  border-radius: 16px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-md);
  min-width: 140px;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
}

.print-view .stat-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: var(--accent-primary);
  margin-bottom: 0.5rem;
}

.print-view .stat-number {
  color: var(--text-secondary);
}

.stat-label {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

/* Content Section */
.canvas-content {
  max-width: 1200px;
  margin: 0 auto;
}

.empty-canvas {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

.empty-canvas-icon {
  width: 4rem;
  height: 4rem;
  margin-bottom: 1rem;
  color: var(--text-tertiary);
}

.empty-canvas h2 {
  margin-bottom: 1rem;
  color: var(--text-primary);
}

.empty-canvas p {
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.start-chatting-button {
  padding: 16px 32px;
  background: var(--accent-gradient);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
}

.start-chatting-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
}

/* Sections */
.sections-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.canvas-section {
  background: var(--bg-primary);
  border-radius: 16px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  transition: all 0.3s ease;
}

.canvas-section:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
}

.print-view .canvas-section {
  background: white;
  border: 1px solid var(--border-secondary);
  color: black;
  page-break-inside: avoid;
  margin-bottom: 1rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.section-header:hover {
  background: var(--bg-secondary);
}

.print-view .section-header:hover {
  background: var(--bg-tertiary);
}

.section-header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1 1;
}

.section-icon {
  width: 2rem;
  height: 2rem;
  color: var(--feature-icon-color);
}

.print-view .section-icon {
  color: var(--text-secondary);
}

.section-titles {
  flex: 1 1;
}

.section-title {
  margin: 0 0 0.25rem 0;
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--text-primary);
}

.section-description {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.section-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.9rem;
}

.insight-count {
  background: var(--feature-bg);
  color: var(--accent-primary);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-weight: 500;
}

[data-theme="dark"] .insight-count {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.print-view .insight-count {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.expand-arrow {
  transition: transform 0.3s ease;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.expand-arrow.expanded {
  transform: rotate(180deg);
}

.section-content {
  padding: 0 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid var(--border-primary);
}

.print-view .section-content {
  border-top: 1px solid var(--border-secondary);
}

.empty-section {
  text-align: center;
  padding: 2rem;
  color: var(--text-tertiary);
}

.empty-icon {
  width: 2rem;
  height: 2rem;
  margin-bottom: 1rem;
}

/* Insights */
.insights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.insight-card {
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid var(--border-primary);
  transition: all 0.3s ease;
}

.insight-card:hover {
  background: var(--bg-tertiary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.print-view .insight-card {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-secondary);
  color: black;
  page-break-inside: avoid;
  break-inside: avoid;
}

.insight-content {
  margin-bottom: 1rem;
  line-height: 1.5;
  font-size: 0.95rem;
  color: var(--text-primary);
}

.empty-canvas-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 1.75rem;
}

.empty-canvas-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 46px;
  padding: 0 22px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.005em;
  cursor: pointer;
  transition: transform 0.18s cubic-bezier(0.4, 0, 0.2, 1),
              box-shadow 0.22s ease,
              background 0.18s ease,
              border-color 0.18s ease,
              color 0.18s ease;
  border: 1px solid transparent;
}

.empty-canvas-btn .empty-canvas-btn-arrow {
  transition: transform 0.18s ease;
}

.empty-canvas-btn:hover .empty-canvas-btn-arrow {
  transform: translateX(3px);
}

.empty-canvas-btn:active {
  transform: translateY(1px);
}

/* Primary — Start Chatting */
.empty-canvas-btn.primary {
  background: var(--accent-gradient);
  color: #ffffff;
  box-shadow: 0 6px 18px -6px rgba(99, 102, 241, 0.55),
              inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.empty-canvas-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -8px rgba(99, 102, 241, 0.7),
              inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

/* Secondary — Process Existing Chats */
.empty-canvas-btn.secondary {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border-color: var(--border-primary);
}

.empty-canvas-btn.secondary:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -6px rgba(0, 0, 0, 0.15);
}

[data-theme="dark"] .empty-canvas-btn.secondary {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
  color: var(--text-primary);
}

[data-theme="dark"] .empty-canvas-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--accent-primary);
  color: #ffffff;
}

.inline-loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 1.25rem 0;
}

.inline-loading-spinner .spinning {
  animation: spin 2s linear infinite;
  width: 2rem;
  height: 2rem;
  color: var(--accent-primary);
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.insight-footer {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: var(--text-tertiary);
}

.insight-source {
  font-weight: 500;
  color: var(--accent-primary);
}

.print-view .insight-source {
  color: var(--text-secondary);
}

/* Loading State */
.canvas-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--bg-gradient);
  color: var(--text-primary);
}

.loading-spinner {
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--border-primary);
  border-top: 3px solid var(--accent-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

/* Print Styles */
.print-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 1rem;
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-secondary);
  border-top: 1px solid var(--border-primary);
}

@media print {
  .canvas-page {
    background: white !important;
    color: black !important;
    padding: 0.5rem !important;
  }

  .back-button,
  .header-actions {
    display: none !important;
  }

  .canvas-section {
    page-break-inside: avoid;
    margin-bottom: 1rem;
  }

  .insight-card {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .canvas-page {
    padding: 1rem;
  }

  .canvas-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .header-left {
    justify-content: center;
  }

  .canvas-stats {
    flex-direction: column;
    gap: 1rem;
  }

  .insights-grid {
    grid-template-columns: 1fr;
  }

  .canvas-title {
    font-size: 1.5rem;
  }

  .stat-item {
    min-width: auto;
  }
}

/* Canvas Copyright Footer */
.canvas-copyright-footer {
  padding: 24px;
  text-align: center;
  border-top: 1px solid var(--border-light, #e5e7eb);
  margin-top: 32px;
}`, "",{"version":3,"sources":["webpack://./src/styles/CanvasPage.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,yHAAyH;EACzH,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf;;;;8BAI4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,cAAc;EACd;qDACmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B;qDACmD;AACrD;;AAEA,uCAAuC;AACvC;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;AAClB","sourcesContent":["/* CanvasPage.css - PhD Canvas Page Styling */\n\n.canvas-page {\n  min-height: 100vh;\n  background: var(--bg-gradient);\n  color: var(--text-primary);\n  padding: 2rem;\n}\n\n.canvas-page.print-view {\n  background: white;\n  color: black;\n  padding: 1rem;\n}\n\n/* Header Section */\n.canvas-header {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  margin-bottom: 2rem;\n  background: var(--bg-primary);\n  padding: 1.5rem;\n  border-radius: 16px;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-lg);\n}\n\n.canvas-header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.print-view .canvas-header {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 10px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.back-button:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.print-view .back-button {\n  display: none;\n}\n\n.canvas-title-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.canvas-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n  margin-bottom: 0.25rem;\n  color: var(--text-primary);\n}\n\n.canvas-title-icon {\n  color: var(--feature-icon-color);\n}\n\n.canvas-subtitle {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 1rem;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.canvas-powered-by {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--text-tertiary);\n  font-size: 12px;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n\n.canvas-powered-by:hover {\n  opacity: 0.8;\n}\n\n.canvas-powered-by-logo {\n  height: 1em;\n  width: auto;\n  vertical-align: middle;\n}\n\n.print-view .header-actions {\n  display: none;\n}\n\n/* Icon-only buttons in canvas header */\n.canvas-icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.12s ease, box-shadow 0.18s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.canvas-icon-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.canvas-icon-btn:hover:not(:disabled) {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.canvas-icon-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Clear-canvas variant — destructive */\n.clear-canvas-btn {\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.35);\n}\n\n.clear-canvas-btn:hover:not(:disabled) {\n  background: #ef4444;\n  color: #ffffff;\n  border-color: #ef4444;\n  box-shadow: 0 4px 12px -2px rgba(239, 68, 68, 0.45);\n}\n\n[data-theme=\"dark\"] .clear-canvas-btn {\n  color: #f87171;\n  border-color: rgba(248, 113, 113, 0.4);\n}\n\n[data-theme=\"dark\"] .clear-canvas-btn:hover:not(:disabled) {\n  background: #ef4444;\n  color: #ffffff;\n  border-color: #ef4444;\n}\n\n.action-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 10px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.action-button:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.action-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.action-icon.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Stats Section */\n.canvas-stats {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  justify-content: center;\n}\n\n.stat-item {\n  text-align: center;\n  background: var(--bg-primary);\n  padding: 1.5rem;\n  border-radius: 16px;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-md);\n  min-width: 140px;\n  transition: all 0.3s ease;\n}\n\n.stat-item:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-xl);\n}\n\n.print-view .stat-item {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n}\n\n.stat-number {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--accent-primary);\n  margin-bottom: 0.5rem;\n}\n\n.print-view .stat-number {\n  color: var(--text-secondary);\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n/* Content Section */\n.canvas-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.empty-canvas {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.empty-canvas-icon {\n  width: 4rem;\n  height: 4rem;\n  margin-bottom: 1rem;\n  color: var(--text-tertiary);\n}\n\n.empty-canvas h2 {\n  margin-bottom: 1rem;\n  color: var(--text-primary);\n}\n\n.empty-canvas p {\n  margin-bottom: 1.5rem;\n  line-height: 1.6;\n}\n\n.start-chatting-button {\n  padding: 16px 32px;\n  background: var(--accent-gradient);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-md);\n}\n\n.start-chatting-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-xl);\n}\n\n/* Sections */\n.sections-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.canvas-section {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.canvas-section:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-xl);\n}\n\n.print-view .canvas-section {\n  background: white;\n  border: 1px solid var(--border-secondary);\n  color: black;\n  page-break-inside: avoid;\n  margin-bottom: 1rem;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.section-header:hover {\n  background: var(--bg-secondary);\n}\n\n.print-view .section-header:hover {\n  background: var(--bg-tertiary);\n}\n\n.section-header-content {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n}\n\n.section-icon {\n  width: 2rem;\n  height: 2rem;\n  color: var(--feature-icon-color);\n}\n\n.print-view .section-icon {\n  color: var(--text-secondary);\n}\n\n.section-titles {\n  flex: 1;\n}\n\n.section-title {\n  margin: 0 0 0.25rem 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.section-description {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.section-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 0.9rem;\n}\n\n.insight-count {\n  background: var(--feature-bg);\n  color: var(--accent-primary);\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n[data-theme=\"dark\"] .insight-count {\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\n.print-view .insight-count {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n.expand-arrow {\n  transition: transform 0.3s ease;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.expand-arrow.expanded {\n  transform: rotate(180deg);\n}\n\n.section-content {\n  padding: 0 1.5rem 1.5rem 1.5rem;\n  border-top: 1px solid var(--border-primary);\n}\n\n.print-view .section-content {\n  border-top: 1px solid var(--border-secondary);\n}\n\n.empty-section {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-tertiary);\n}\n\n.empty-icon {\n  width: 2rem;\n  height: 2rem;\n  margin-bottom: 1rem;\n}\n\n/* Insights */\n.insights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.insight-card {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  padding: 1.25rem;\n  border: 1px solid var(--border-primary);\n  transition: all 0.3s ease;\n}\n\n.insight-card:hover {\n  background: var(--bg-tertiary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.print-view .insight-card {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-secondary);\n  color: black;\n  break-inside: avoid;\n}\n\n.insight-content {\n  margin-bottom: 1rem;\n  line-height: 1.5;\n  font-size: 0.95rem;\n  color: var(--text-primary);\n}\n\n.empty-canvas-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 1.75rem;\n}\n\n.empty-canvas-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 46px;\n  padding: 0 22px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  cursor: pointer;\n  transition: transform 0.18s cubic-bezier(0.4, 0, 0.2, 1),\n              box-shadow 0.22s ease,\n              background 0.18s ease,\n              border-color 0.18s ease,\n              color 0.18s ease;\n  border: 1px solid transparent;\n}\n\n.empty-canvas-btn .empty-canvas-btn-arrow {\n  transition: transform 0.18s ease;\n}\n\n.empty-canvas-btn:hover .empty-canvas-btn-arrow {\n  transform: translateX(3px);\n}\n\n.empty-canvas-btn:active {\n  transform: translateY(1px);\n}\n\n/* Primary — Start Chatting */\n.empty-canvas-btn.primary {\n  background: var(--accent-gradient);\n  color: #ffffff;\n  box-shadow: 0 6px 18px -6px rgba(99, 102, 241, 0.55),\n              inset 0 1px 0 rgba(255, 255, 255, 0.18);\n}\n\n.empty-canvas-btn.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px -8px rgba(99, 102, 241, 0.7),\n              inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n/* Secondary — Process Existing Chats */\n.empty-canvas-btn.secondary {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border-color: var(--border-primary);\n}\n\n.empty-canvas-btn.secondary:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px -6px rgba(0, 0, 0, 0.15);\n}\n\n[data-theme=\"dark\"] .empty-canvas-btn.secondary {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .empty-canvas-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--accent-primary);\n  color: #ffffff;\n}\n\n.inline-loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 1.25rem 0;\n}\n\n.inline-loading-spinner .spinning {\n  animation: spin 2s linear infinite;\n  width: 2rem;\n  height: 2rem;\n  color: var(--accent-primary);\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.insight-footer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8rem;\n  color: var(--text-tertiary);\n}\n\n.insight-source {\n  font-weight: 500;\n  color: var(--accent-primary);\n}\n\n.print-view .insight-source {\n  color: var(--text-secondary);\n}\n\n/* Loading State */\n.canvas-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background: var(--bg-gradient);\n  color: var(--text-primary);\n}\n\n.loading-spinner {\n  width: 3rem;\n  height: 3rem;\n  border: 3px solid var(--border-primary);\n  border-top: 3px solid var(--accent-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n/* Print Styles */\n.print-footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: white;\n  padding: 1rem;\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  border-top: 1px solid var(--border-primary);\n}\n\n@media print {\n  .canvas-page {\n    background: white !important;\n    color: black !important;\n    padding: 0.5rem !important;\n  }\n\n  .back-button,\n  .header-actions {\n    display: none !important;\n  }\n\n  .canvas-section {\n    page-break-inside: avoid;\n    margin-bottom: 1rem;\n  }\n\n  .insight-card {\n    break-inside: avoid;\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .canvas-page {\n    padding: 1rem;\n  }\n\n  .canvas-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .header-left {\n    justify-content: center;\n  }\n\n  .canvas-stats {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .insights-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .canvas-title {\n    font-size: 1.5rem;\n  }\n\n  .stat-item {\n    min-width: auto;\n  }\n}\n\n/* Canvas Copyright Footer */\n.canvas-copyright-footer {\n  padding: 24px;\n  text-align: center;\n  border-top: 1px solid var(--border-light, #e5e7eb);\n  margin-top: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
